import React from 'react';
import { cn } from '../../utils/cn';

const badgeVariants = {
  default: 'bg-primary text-primary-foreground',
  secondary: 'bg-[#E8FCF7] text-[#006600]',
  destructive: 'bg-[#BB0000] text-white',
  outline: 'border border-border text-[#4A5B63] bg-white',
  success: 'bg-success text-success-foreground',
  warning: 'bg-warning text-warning-foreground',
  info: 'bg-[#000000] text-white',
};

const badgeSizes = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-2.5 py-1.5 text-sm',
  lg: 'px-3 py-2 text-base',
};

const Badge = React.forwardRef(({
  className,
  variant = 'default',
  size = 'md',
  children,
  ...props
}, ref) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2';
  
  const variantClasses = badgeVariants[variant];
  const sizeClasses = badgeSizes[size];
  
  const classes = cn(
    baseClasses,
    variantClasses,
    sizeClasses,
    className
  );

  return (
    <div
      ref={ref}
      className={classes}
      {...props}
    >
      {children}
    </div>
  );
});

Badge.displayName = 'Badge';

export { Badge, badgeVariants, badgeSizes };
